<!-- TAB B -->
<div *ngIf="parent == prefix_fleet">
    <button type="button" [ngClass]="(show_reports)?'btn-success':'btn-secondary'" class="btn btn-md mb-1" (click)="toggleReports('reports')">
        <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-file-text"></i></span>&nbsp;Damage Reports
    </button> &nbsp;
    <button type="button" [ngClass]="(show_requests)?'btn-success':'btn-secondary'" class="btn btn-md mb-1" (click)="toggleReports('requests')">
        <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-wrench"></i></span>&nbsp; Repair Requests
    </button> &nbsp;
</div>
<!-- Repair Requests -->
<div *ngIf="(show_requests && (parent == prefix_fleet))">


    <div class="clearfix">
        <ul class="nav nav-tabs custom top">
            <li class="nav-item">
                <a class="nav-link active" data-toggle="tab" href="#tabRepairRequest"><strong>Repair Request</strong></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tabRepairConsolidated"><strong>Repair Consolidated</strong></a>
            </li>
        </ul>
    </div>

    <div class="tab-content top">

    <div class="tab-pane active" id="tabRepairRequest">
        <div class="row pt-0">
            <div class="col-md-12">
            <!--    <button type="button" class="btn btn-secondary btn-sm mb-1 mr-1" aria-expanded="false"
                ngbTooltip="Add New Repair Request" (click)="openRepairRequestModal(null)">
                    <span class="sr-only">Add</span>
                    <i class="fa fa-lg fa-plus"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Add</span>
                </button>-->

                <button type="button" class="btn btn-secondary btn-sm mb-1 mr-2" aria-expanded="false" [disabled]="damage_rows.length < 1  ||repair_request_Count < 1"
                ngbTooltip="Add New Repair Request" (click)="openRRModal(null)">
                    <span class="sr-only">Add</span>
                    <i class="fa fa-lg fa-plus"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Add</span>
                </button>

                <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print('repairrequest-print-section')" placement="bottom" [disabled]="repairRequestCount < 1"
                    ngbTooltip="Print List">
                    <i class="fa fa-lg fa-print"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
                </button>

                <div class="btn-group mr-1">
                    <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="repairRequestCount < 1"
                        placement="bottom" ngbTooltip="Export List">
                        <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
                    </button>
                    <div class="dropdown-menu fs-12">
                        <a (click)="repairReq_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                        <a (click)="repairReq_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                        <a (click)="repairReq_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                    </div>
                </div>

                <!-- <button type="button" [ngClass]="(showSidebar)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
                    (click)="toggleSideBar()" placement="bottom" ngbTooltip="Toggle Sidebar">
                <i class="fa fa-lg fa-toggle-right"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Sidebar</span>
                </button> -->
            
                <div class="btn-group mb-1">
                    <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    placement="bottom" ngbTooltip="Show/Hide Columns">
                        <span class="sr-only">Toggle Dropdown</span>
                        <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                    </button>
                    <div class="dropdown-menu fs-12" style="width: 150px;">
                        <div class="col-md-12 mb-3 fs-12">
                            <input type="checkbox" [(ngModel)]="showRequestDate"> Date<br />
                            <input type="checkbox" [(ngModel)]="showRequestDescription"> Description<br />
                        </div>
                    </div>
                </div>

            </div>
        </div><br/>

        <!-- <div class="row pt-0">
                    <div class="col-md-8">
                        <div widget class="card border-0 box-shadow" *ngIf="showFilters">
                            <div class="card-header border-0 text-muted">
                                <h5 class="mb-0">Search Repair Requests:</h5>
                                <div class="widget-controls">
                                    <a data-widgster="close"class="transition" (click)="toggleFilters()"><i class="fa fa-times"></i></a>
                                </div>  
                            </div>
                            <div class="card-body card-header pt-0 widget-body">
                                <div class="row">
                                    <div class="form-group col-md-4" *ngIf="parent!=prefix_fleet">
                                        <label>REGO:</label>
                                        <input class="form-control form-control-sm" type="text" [(ngModel)]="filterRepairRequestRego" (keyup)="updateFilter(prefixRepairRequest)"> 
                                    </div>
                                </div>
                                <div class="row" *ngIf="!isFilterEmpty">
                                    <div class="col-md-12">
                                        <button  type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters(prefixRepairRequest)">
                                            <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-filter"></i></span>
                                            <span >Reset Filters</span>
                                        </button> &nbsp;
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>
        </div> -->
        <!-- <br *ngIf="showFilters" /> -->
        <div class="row">
            <div class="col-md-12">
                <div class="card-body pt-0 widget-body">
                    <span  class="card-body">
                            <a (click)="onClickRRStatus('Cancelled');">
                            <span class="badge badge-pill badge-danger pull-right">
                            <span [hidden]="filterStatus != 'Cancelled'">
                            <i class="fa fa-check"></i>&nbsp;</span>Cancelled</span></a>

                            <a (click)="onClickRRStatus('Done');">
                            <span class="badge badge-pill badge-completed pull-right">
                            <span [hidden]="filterStatus != 'Done'">
                            <i class="fa fa-check"></i>&nbsp;</span>Resolved</span></a>

                            <a (click)="onClickRRStatus('Acknowledged');">
                            <span class="badge badge-pill badge-dispatched pull-right">
                            <span [hidden]="filterStatus != 'Acknowledged'">
                            <i class="fa fa-check"></i>&nbsp;</span>Acknowledged</span></a>

                            <a (click)="onClickRRStatus('Pending');">
                            <span class="badge badge-pill badge-pending pull-right">
                            <span [hidden]="filterStatus != 'Pending'">
                            <i class="fa fa-check"></i>&nbsp;</span>Pending</span></a>

                    </span><br />
                    <ngx-loading [show]="loading_indicator2"></ngx-loading>
                    <ngx-datatable *ngIf="request_rows && !loading_indicator2"
                        [loadingIndicator]="loading_indicator2"
                        class="material"
                        [rows]="request_rows"
                        [columnMode]="'force'"
                        [columns]="request_columns"
                        [footerHeight]="40"
                        [rowHeight]="'auto'"
                        [limit]="10"
                        [selected]="selected2"
                        [selectionType]="'single'"
                        [scrollbarH]="true"
                        (select)='onSelect2($event)'
                        >

                        <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="130" [cellClass]="getCellClass">
                            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                                <div align="left" style="padding-right:20px">
                                    <a class="hover difot" title="Details" (click)="openRRDetails()"><i class="fa fa-lg fa-book"></i></a>
                                    <a container="body" placement="top" ngbTooltip="Edit" (click)="openRRModal(row)" *ngIf="row.status_id < 3"><i class="fa fa-lg fa-pencil mr-1"></i></a>
                                    <a *ngIf="row.status_id < 3" container="body" placement="top" ngbTooltip="Create New Task" (click)="openPromptModalTask(modalTaskForm, null, row.id, prefixRepairRequest)"><i class="fa fa-lg fa-plus-square-o mr-1"></i></a>
                                    <a container="body" *ngIf="row.status_id < 3" placement="top" ngbTooltip="Select an Action (Cancel)" (click)="openSelectAnAction(row)"><i class="fa fa-lg fa-ban mr-1"></i></a>
                                    <a *ngIf="row.repairRequestTaskCount > 0" container="body" placement="top" ngbTooltip="Mark as Completed" (click)="openMarkCompleteModal(modalMarkCompleted, prefixRepairRequest)"><i class="fa fa-lg fa-check-square-o mr-1"></i></a>
                                    <a *ngIf="row.status_id == 2" container="body" placement="top" ngbTooltip="Add Repair" (click)="openRepairModal(row)"><i
                                        class="fa fa-lg fa-plus-circle"></i></a>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Date" prop="date_submitted"  headerClass="header" [cellClass]="getCellClass" *ngIf="showRequestDate">
                            <ng-template let-value="value" ngx-datatable-cell-template>
                                {{ (formatDate(value) !== null) ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }} 
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Description" prop="text"  headerClass="header" [cellClass]="getCellClass" *ngIf="showRequestDescription"></ngx-datatable-column>
                        
                        <ngx-datatable-column name="File" prop="filename" headerClass="header" [cellClass]="getCellClass" *ngIf="showRequestFile">
                            <ng-template let-value="value" ngx-datatable-cell-template>
                                <a href="{{fileStoragePath}}/repair_request/{{value}}" target="_new">{{value}}</a>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>

            <!-- DETAILS -->
            <ng-template #modalRRDetails let-close="close">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0" style="text-align: center;">Details</h5>     
                </div>
                <br>
                    <div widget class="card border-0 box-shadow selected-column">
                            <div class="pt-0 widget-body">
                                    <ul>
                                        <div *ngIf="selected2">
                                            <div *ngFor='let sel2 of selected2'>
                                                <div class="col-md-12">
                                                    <label class="titleHeader">{{sel2["rego"]}}</label>&nbsp;&nbsp;<a *ngIf="sel2['filename']!==null && sel2['filename']!==''" href="{{fileStoragePath}}/repair_request/{{sel2['filename']}}" target="_new" title="View File"><i class="fa fa-file"></i></a><br/>
                                                    <strong class="text-muted">Date Submitted: </strong> <span>{{ (formatDate(sel2["date_submitted"]) !== null) ? (formatDate(sel2["date_submitted"]) | date: 'dd MMM yyyy') : "No Date"  }} - {{sel2.time_submitted}}</span><br />
                                                    <strong class="text-muted">Fleet Type: </strong> <span>{{sel2.fleet_type}} <span *ngIf="sel2.subtype !=='' && sel2.subtype != null">- {{sel2.subtype}}</span></span><br />
                                                    <strong class="text-muted">Description: </strong> <span>{{sel2.text}}</span><br /> 
                                                    <strong class="text-muted">Status: </strong> 
                                                        <span *ngIf="sel2.status_id == 3">Resolved</span>
                                                        <span *ngIf="sel2.status_id == 2">Acknowledged</span>
                                                        <span *ngIf="sel2.status_id == 1">Pending</span>
                                                        <span *ngIf="sel2.status_id == 4">Cancelled</span>
                                                    <br /> 
                                                </div><br />
                                            </div>
                                        </div>
                                        <div *ngIf="!selected2.length" class="text-center">
                                            <p> Select an item to display details. </p>
                                        </div>
                                    </ul>  
                            </div>
                    </div>
                    <br />
                    <div widget class="card border-0 box-shadow selected-column">
                            <div class="card-header transparent border-0 text-muted">
                                <h6 class="mb-0" style="text-align: center;">Repair Request Tasks</h6>
                            </div>
                            <div class="card-body pt-0 widget-body">
                                <div *ngIf="selected2">
                                    <div *ngFor='let sel2 of selected2'>
                                        <div *ngIf="tasksByRepairRequestId.length > 0">
                                            <table class="table table-sm" style="border: none;">
                                                <thead>
                                                    <tr>
                                                        <th style="border: none; text-align: center;"></th>
                                                        <th style="border: none; text-align: center; font-size: 11px;">Title</th>
                                                        <th style="border: none; text-align: center; font-size: 11px;">Assigned To</th>
                                                        <th style="border: none; text-align: center; font-size: 11px;">% Done</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let task of tasksByRepairRequestId | paginate: { itemsPerPage: 5, currentPage: rrp }">
                                                        <td style="border: none; text-align: center; font-size: 11px;"><small><i class="fa fa-pencil" title="Edit Task" (click)="openPromptModalTask(modalTaskForm, task, sel2.id, prefixRepairRequest)"></i> <i *ngIf="task.status_name !== 'Completed' && task.status_name !== 'Cancelled'" class="fa fa-check" title="Mark Task Completed" (click)="openPromptModal(modalMarkTaskCompleted,task, prefixRepairRequest)"></i>
                                                            <i class="fa fa-trash" title="Delete Task" (click)="openPromptModal(modalDeleteTask,task, prefixRepairRequest)"></i></small>
                                                        </td>
                                                        <td style="border: none; text-align: center; font-size: 11px;">{{task.title}}</td>
                                                        <td style="border: none; text-align: center; font-size: 11px;">{{task.assignedTo_name}}</td>
                                                        <td style="border: none; text-align: center; font-size: 11px;">{{task.percent_done}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div style="text-align:right;"><button type="button" class="btn btn-outline-secondary" style="font-size: smaller;" (click)="openMarkCompleteModal(modalMarkCompleted, prefixRepairRequest)">
                                                <span class="badge badge-pill badge-white text-primary"></span>Mark as Completed
                                            </button></div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="bg-white text-center">
                                                        <small><pagination-controls autoHide="true" (pageChange)="rrp = $event" maxSize="10"></pagination-controls></small>
                                                    </div>  
                                                </div>
                                            </div> 
                                        </div>   
                                    </div> <br>
                                    <div *ngIf="tasksByRepairRequestId.length == 0" class="text-center">
                                        <p>No recorded task for this repair request.</p> 
                                    </div>
                            </div>   
                        </div>
                    </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-secondary" (click)="close()" ngbAutofocus>Close</button>
                </div>
            </ng-template>
            <!-- END DETAILS -->
        </div> <!-- END ROW -->
    </div>

    <div class="tab-pane" id="tabRepairConsolidated">

        <div class="row pt-0">
            <div class="col-md-12">
                <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print('repairpairing-print-section')" placement="bottom" [disabled]="repairPairingCount  < 1"
                    ngbTooltip="Print List">
                    <i class="fa fa-lg fa-print"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
                </button>

                <div class="btn-group mr-1">
                    <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="repairPairingCount  < 1"
                        placement="bottom" ngbTooltip="Export List">
                        <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
                    </button>
                    <div class="dropdown-menu fs-12">
                        <a (click)="rrcReq_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                        <a (click)="rrcReq_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                        <a (click)="rrcReq_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                    </div>
                </div>

                <button type="button" [ngClass]="(showFilters2)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1" (click)="toggleFilters2()" [disabled]="repairPairingCount  < 1"  placement="bottom" ngbTooltip="Filter List">
                    <i class="fa fa-lg fa-filter"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
                </button>

                <!-- <button type="button" [ngClass]="(showSidebar2)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
                    (click)="toggleSideBar2()" placement="bottom" ngbTooltip="Toggle Sidebar" [disabled]="repairPairingCount  < 1">
                <i class="fa fa-lg fa-toggle-right"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Sidebar</span>
                </button> -->
            
                <div class="btn-group mb-1">
                    <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    placement="bottom" ngbTooltip="Show/Hide Columns">
                        <span class="sr-only">Toggle Dropdown</span>
                        <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                    </button>
                    <div class="dropdown-menu fs-12" style="width: 150px;">
                        <div class="col-md-12 mb-3 fs-12">
                            <input type="checkbox" [(ngModel)]="showPairingRequestID"> Request ID<br />
                            <input type="checkbox" [(ngModel)]="showPairingDesc"> Description<br />
                            <input type="checkbox" [(ngModel)]="showPairingDriver"> Driver Name<br />
                            <input type="checkbox" [(ngModel)]="showPairingRating"> Rating<br />
                            <input type="checkbox" [(ngModel)]="showPairingStatus"> Status<br />
                        </div>
                    </div>
                </div>
            </div>
        </div><br/>
             <!-- SEARCH RRC LIST -->
             <div class="row mb-1 pt-0" *ngIf="showFilters2">
                <div class="col-xl-12 mb-12">
                    <div widget class="card border-0 box-shadow" *ngIf="showFilters2">
                        <div class="card-header border-0 text-muted">
                            <h5 class="mb-0">Search Report Consolidated List:</h5>
                            <div class="widget-controls"> 
                                <a data-widgster="close"class="transition" (click)="toggleFilters2()"><i class="fa fa-times"></i></a>
                            </div>  
                        </div>
                        <div class="card-body card-header pt-0 widget-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <label>Driver:</label> 
                                    <input type="text" class="form-control form-control-sm" (keyup)="updateRConsolicatedFilter()" [(ngModel)]="filterDriver">
                                </div>
                                <div class="col-md-4">
                                    <label>Description:</label> 
                                    <input type="text" class="form-control form-control-sm" (keyup)="updateRConsolicatedFilter()" [(ngModel)]="filterDescription">
                                </div>
                            </div>
                            
                            <br/>
                            <div class="row" *ngIf="!isFilterEmpty">
                                <div class="col-md-12">
                                    <button  type="button" class="btn btn-sm btn-success btn-sm mb-1" (click)="resetRCFilters()">
                                            <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-filter"></i></span>
                                            <span> Reset Filters</span>
                                    </button> &nbsp;
                                </div> 
                            </div>                                  
                        </div>
                    </div>
                </div> 
            </div>


        <!-- <br *ngIf="showFilters" /> -->

        <div class="row">
            <div class="col-md-12">
                <div class="card-body pt-0 widget-body">
                    <span  class="card-body">
                        <a (click)="onClickRCStatus('Cancelled');">
                            <span class="badge badge-pill badge-danger pull-right">
                            <span [hidden]="filterStatus != 'Cancelled'">
                            <i class="fa fa-check"></i>&nbsp;</span>Cancelled</span></a>

                            <a (click)="onClickRCStatus('Done');">
                            <span class="badge badge-pill badge-completed pull-right">
                            <span [hidden]="filterStatus != 'Done'">
                            <i class="fa fa-check"></i>&nbsp;</span>Resolved</span></a>

                            <a (click)="onClickRCStatus('Acknowledged');">
                            <span class="badge badge-pill badge-dispatched pull-right">
                            <span [hidden]="filterStatus != 'Acknowledged'">
                            <i class="fa fa-check"></i>&nbsp;</span>Acknowledged</span></a>

                            <a (click)="onClickRCStatus('Pending');">
                            <span class="badge badge-pill badge-pending pull-right">
                            <span [hidden]="filterStatus != 'Pending'">
                            <i class="fa fa-check"></i>&nbsp;</span>Pending</span></a>
                            
                    </span><br />
                    <ngx-loading [show]="loading_indicator4"></ngx-loading>
                    <ngx-datatable  *ngIf="request_pairings_rows && !loading_indicator4"
                        [loadingIndicator]="loading_indicator4"
                        class="material"
                        [rows]="request_pairings_rows"
                        [columnMode]="'force'"
                        [columns]="pairing_columns"
                        [footerHeight]="40"
                        [rowHeight]="'auto'"
                        [limit]="10"
                        [selected]="selected4"
                        [selectionType]="'single'"
                        [scrollbarH]="true"
                        (select)='onSelect4($event)'
                        >

                        <ngx-datatable-column name="Operations" prop=""  headerClass="header" [cellClass]="getCellClass2">
                            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                                <div align="left" style="padding-right:20px">
                                    <a class="hover difot" title="Details" (click)="openRepairConsolidatedDetails()"><i class="fa fa-lg fa-book"></i></a>&nbsp;
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Request ID" prop="request_id"  headerClass="header" [cellClass]="getCellClass2" *ngIf="showPairingRequestID"></ngx-datatable-column>
                        <ngx-datatable-column name="Description" prop="description"  headerClass="header" [cellClass]="getCellClass2" *ngIf="showPairingDesc"></ngx-datatable-column>
                        <ngx-datatable-column name="Driver Name" prop="driver_name"  headerClass="header" [cellClass]="getCellClass2" *ngIf="showPairingDriver"></ngx-datatable-column>
                        <ngx-datatable-column name="Status" prop="status_name"  headerClass="header" [cellClass]="getCellClass2" *ngIf="showPairingStatus"></ngx-datatable-column>
                        <ngx-datatable-column name="Rating" prop="rating_name"  headerClass="header" [cellClass]="getCellClass2" *ngIf="showPairingRating"></ngx-datatable-column>
                        <ngx-datatable-column name="File" prop="file" headerClass="header" [cellClass]="getCellClass2" *ngIf="showRepairConsolidated">
                            <ng-template let-value="value" ngx-datatable-cell-template>
                                <a href="{{fileStoragePath}}/report/{{value}}" target="_new">{{value}}</a>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>

            <!-- DETAILS -->
            <ng-template #modalRCDetails let-close="close">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0" style="text-align: center;">Repair Consolidated Details</h5>     
                </div><br>
                <div widget class="card border-0 box-shadow selected-column">
                    <div >
                        <ul>
                            <div *ngIf="selected4">
                                <div *ngFor='let sel4 of selected4'>
                                    <div class="col-md-12">
                                        <!-- <label class="titleHeader">{{sel2["rego"]}}</label>&nbsp;&nbsp;<a *ngIf="sel2['filename']!==null && sel2['filename']!==''" href="{{fileStoragePath}}/repairrequest/{{sel2['filename']}}" target="_new" title="View File"><i class="fa fa-file"></i></a><br/> -->
                                        <strong class="text-muted">Driver Name:</strong> <span class="text-muted"> {{sel4.driver_name}}</span><br />
                                        <strong class="text-muted">Description:</strong> <span class="text-muted"> {{sel4.description}}</span><br /> 
                                        <strong class="text-muted">Rating:</strong> <span class="text-muted"> {{sel4.rating_name}}</span><br /> 
                                        <strong class="text-muted">Status:</strong> 
                                        <span *ngIf="sel4.status_name == 'Done'" class="text-muted"> Resolved</span>
                                        <span *ngIf="sel4.status_name == 'Acknowledged'" class="text-muted"> Acknowledged</span>
                                        <span *ngIf="sel4.status_name == 'Pending'" class="text-muted"> Pending</span>
                                        <span *ngIf="sel4.status_name == 'Cancelled'" class="text-muted"> Cancelled</span>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!selected4.length" class="text-center">
                                <p> Select an item to display details. </p>
                            </div>
                        </ul>  
                    </div>
                </div><br/>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-secondary" (click)="close()" ngbAutofocus>Close</button>
                </div>
            </ng-template>
            <!-- END DETAILS -->
        </div> <!-- END ROW -->
    </div>

    <div class="row">
        <div class="col-md-12">
            <small class="ml-1"><i>Click on a row to select. Details on a selected row are shown on the right window.</i></small>
        </div>
    </div>
    </div>
</div>

<!-- Damage Reports -->
<div *ngIf="show_reports">
    <div class="row">
        <div class="col-md-12">
            <button type="button" class="btn btn-secondary btn-sm mb-1 mr-1" aria-expanded="false"
            placement="bottom" ngbTooltip="Add New Report" (click)="openDamageReportModal(null)">
                <span class="sr-only">Add</span>
                <i class="fa fa-lg fa-plus"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Add</span>
            </button>
            
            
            <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print('report-print-section')" placement="bottom" [disabled]="damageReportCount < 1"
                ngbTooltip="Print List">
                <i class="fa fa-lg fa-print"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
            </button>

            <div class="btn-group mr-1">
                <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="damageReportCount < 1"
                    placement="bottom" ngbTooltip="Export List">
                    <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
                </button>
                <div class="dropdown-menu fs-12">
                    <a (click)="damageRep_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                    <a (click)="damageRep_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                    <a (click)="damageRep_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                </div>
            </div>

            <!-- <button type="button" [ngClass]="(showSidebar)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
                (click)="toggleSideBar()" placement="bottom" ngbTooltip="Toggle Sidebar">
               <i class="fa fa-lg fa-toggle-right"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Sidebar</span>
            </button> -->
           
            <div class="btn-group mb-1">
                <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    placement="bottom" ngbTooltip="Show/Hide Columns">
                    <span class="sr-only">Toggle Dropdown</span>
                    <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                </button>
                <div class="dropdown-menu fs-12" style="width: 150px;">
                    <div class="col-md-12 mb-3 fs-12">
                        <input type="checkbox" [(ngModel)]="showDate"> Date<br />
                        <input type="checkbox" [(ngModel)]="showRego"> REGO<br />
                        <input type="checkbox" [(ngModel)]="showFleetType"> Fleet Type<br />
                        <input type="checkbox" [(ngModel)]="showDescription"> Description<br />
                        <input type="checkbox" [(ngModel)]="showFile"> File<br />
                    </div>
                </div>
            </div>

            <!-- <button  *ngIf="parent == prefix_fleet" type="button" class="btn btn-secondary btn-sm mb-1 ml-1" aria-expanded="false" (click)="openRRModal()" 
            placement="bottom" ngbTooltip="Create Repair Request" [disabled]="damageReportCount < 1">
                <span class="sr-only">Create Repair Request</span>
                <i class="fa fa-lg fa-plus"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Create Repair Request</span>
            </button>-->
        </div>
    </div><br/>
    <!-- <div class="row pt-0">
        <div class="col-md-12">
            <div widget class="card border-0 box-shadow" *ngIf="showFilters">
                <div class="card-header border-0 text-muted">
                    <h5 class="mb-0">Search Damage Report:</h5>
                    <div class="widget-controls">
                        <a data-widgster="close"class="transition" (click)="toggleFilters()"><i class="fa fa-times"></i></a>
                    </div>  
                </div>
                <div class="card-body card-header pt-0 widget-body">
                    <div class="row">
                        <div class="form-group col">
                            <label>Status:</label>
                            <select class="form-control form-control-sm" placeholder="Select" [(ngModel)]="filterDamageReportStatus" (change)="updateFilter(prefixDamageReport)">
                                <option selected disabled>Select..</option>
                                <option *ngFor="let s of report_statuses" value="{{s.id}}">{{s.name}}</option>
                            </select>
                        </div>
                        <div class="form-group col" *ngIf="parent!=prefix_fleet">
                            <label>REGO:</label>
                            <input class="form-control form-control-sm" type="text" [(ngModel)]="filterDamageReportRego" (keyup)="updateFilter(prefixDamageReport)">
                        </div>
                    </div>
                    <div class="row" *ngIf="!isFilterEmpty">
                        <div class="col-md-12">
                            <button  type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters(prefixDamageReport)">
                                    <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-filter"></i></span>
                                    <span >Reset Filters</span>
                            </button> &nbsp;
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    </div> -->
    <br *ngIf="showFilters" />
    
    <div class="row pt-0">
        <div class="col-md-12">
            <span class="card-body">
                <a (click)="onClickDamageReport('Cancelled');">
                    <span class="badge badge-pill badge-danger pull-right">
                    <span [hidden]="filterStatus != 'Cancelled'">
                    <i class="fa fa-check"></i>&nbsp;</span>Cancelled</span></a>

                    <a (click)="onClickDamageReport('Done');">
                    <span class="badge badge-pill badge-completed pull-right">
                    <span [hidden]="filterStatus != 'Done'">
                    <i class="fa fa-check"></i>&nbsp;</span>Resolved</span></a>

                    <a (click)="onClickDamageReport('Acknowledged');">
                    <span class="badge badge-pill badge-dispatched pull-right">
                    <span [hidden]="filterStatus != 'Acknowledged'">
                    <i class="fa fa-check"></i>&nbsp;</span>Acknowledged</span></a>

                    <a (click)="onClickDamageReport('Pending');">
                    <span class="badge badge-pill badge-pending pull-right">
                    <span [hidden]="filterStatus != 'Pending'">
                    <i class="fa fa-check"></i>&nbsp;</span>Pending</span></a>
            </span><br />
            <ngx-loading [show]="loading_indicator3"></ngx-loading>
            <ngx-datatable *ngIf="damage_rows && !loading_indicator3"
                [loadingIndicator]="loading_indicator3"
                class="material hover"
                [rows]="damage_rows"
                [columnMode]="'force'"
                [columns]="damage_columns"
                [footerHeight]="40"
                [rowHeight]="'auto'"
                [limit]="10"
                [selected]="selected3"
                [selectionType]="'single'"
                [scrollbarH]="true"
                (select)='onSelect3($event)'
                >

                <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="130" [cellClass]="getCellClass">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div align="left" style="padding-right:20px">
                            <a class="hover difot" title="Details" (click)="openDamageReportDetails()"><i class="fa fa-lg fa-book"></i></a>&nbsp;
                            <a class="a_icons" container="body" placement="top" ngbTooltip="Edit" (click)="openDamageReportModal(row)"><i class="fa fa-lg fa-pencil"></i></a>&nbsp;
                            <a class="a_icons" container="body" placement="top" ngbTooltip="Delete" (click)="openDeleteObjModal(row, prefixDamageReport, modalDeleteObj)"><i class="fa fa-lg fa-trash"></i></a>&nbsp;
                            <a class="a_icons" container="body" placement="top" ngbTooltip="Create New Task" (click)="openPromptModalTask(modalTaskForm, null, row.id, prefixDamageReport)"><i class="fa fa-lg fa-plus-square-o"></i></a>&nbsp;
                            <a class="a_icons" *ngIf="row.damageReportTaskCount > 0" container="body" placement="top" ngbTooltip="Mark as Completed" (click)="openMarkCompleteModal(modalMarkCompleted, prefixDamageReport)"><i class="fa fa-lg fa-check-square-o"></i></a>
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Date" prop="date_submitted"  headerClass="header" *ngIf="showDate" [cellClass]="getCellClass">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        {{ (formatDate(value) !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }} 
                    </ng-template> 
                </ngx-datatable-column>

                <ngx-datatable-column  *ngIf="showRego" name="REGO" prop="rego"  headerClass="header" [cellClass]="getCellClass"></ngx-datatable-column>
                
                <ngx-datatable-column *ngIf="showFleetType" headerClass="header" [cellClass]="getCellClass">
                    <ng-template let-column="column" ngx-datatable-header-template >Fleet Type</ng-template>
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        {{row.fleet_type}} <span *ngIf="row.subtype !=='' && row.subtype != null">- {{row.subtype}}</span>
                    </ng-template>
                </ngx-datatable-column>               

                <ngx-datatable-column name="Description" prop="text"  headerClass="header" *ngIf="showDescription" [cellClass]="getCellClass"></ngx-datatable-column>

                <ngx-datatable-column name="File" prop="file"  headerClass="header" *ngIf="showFile" [cellClass]="getCellClass">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        <a class="files_hover" href="{{fileStoragePath}}/report/{{value}}" target="_new">{{value}}</a>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>
        <!-- DETAILS SIDEBAR -->
        <ng-template #modalDamageReportDetails let-close="close">
            <div class="card-header transparent border-0 text-muted">
                <h5 class="mb-0" style="text-align: center;">Damage Report Details</h5>     
            </div><br>
        
            <div class="pt-0 widget-body" >
                <ul>
                    <div *ngIf="selected3">
                        <div *ngFor='let sel3 of selected3'>
                            <div class="col-md-12">
                                <label class="titleHeader">{{sel3["rego"]}}</label>&nbsp;&nbsp;<a *ngIf="sel3['file']!==null && sel3['file']!==''" href="{{fileStoragePath}}/report/{{sel3['file']}}" target="_new" title="View File"><i class="fa fa-file"></i></a><br/>
                                <strong class="text-muted">Date Submitted: </strong> <span class="text-muted">{{ (formatDate(sel3["date_submitted"]) !== null) ? (formatDate(sel3["date_submitted"]) | date: 'dd MMM yyyy') : "No Date"  }}-{{sel3.time_submitted}}</span><br />
                                <strong class="text-muted">Fleet Type: </strong> <span class="text-muted">{{sel3.fleet_type}} <span *ngIf="sel3.subtype !=='' && sel3.subtype != null">- {{sel3.subtype}}</span></span><br />
                                <strong class="text-muted">Description: </strong> <span class="text-muted">{{sel3.text}}</span><br/>
                                <strong class="text-muted">Driver: </strong> <span class="text-muted">{{sel3.driver_name}}</span><br />
                                <strong class="text-muted">Rating: </strong> <span class="text-muted">{{sel3.rating}}</span><br />
                                <strong class="text-muted">Status: </strong >
                                    <span *ngIf="sel3.status_id == 3" class="text-muted">Resolved</span>
                                    <span *ngIf="sel3.status_id == 2" class="text-muted">Acknowledged</span>
                                    <span *ngIf="sel3.status_id == 1" class="text-muted">Pending</span>
                                    <span *ngIf="sel3.status_id == 4" class="text-muted">Cancelled</span> 
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!selected3.length" class="text-center">
                        <p> Select an item to display details. </p>
                    </div>
                </ul>   
            </div>
        
        <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-secondary" (click)="close()" ngbAutofocus>Close</button>
        </div>
        
        </ng-template>
            <!-- <div widget class="card border-0 box-shadow selected-column">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0">Damage Report Tasks:</h5>
                </div>
                <div class="card-body pt-0 widget-body">
                    <div *ngIf="selectedDamage.length">
                        <div *ngFor='let sel3 of selected3'>
                            
                            <div>
                                <button type="button" class="btn btn-sm btn-secondary mb-1" (click)="openMarkCompleteModal(modalMarkCompleted, prefixDamageReport)">
                                <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-check-square-o"></i></span>
                                Mark as Completed
                                </button>
                                <br />
                                <table class="table table-sm">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th><small><strong>Title</strong></small></th>
                                            <th><small><strong>Assigned To</strong></small></th>
                                            <th><small><strong>% Done</strong></small></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let task of tasksByDamageReportId | paginate: { itemsPerPage: 5, currentPage: drp }">
                                            <td><small><i class="fa fa-pencil" title="Edit Task" (click)="openPromptModalTask(modalTaskForm, task, sel3.id, prefixDamageReport)"></i> <i *ngIf="task.status_name !== 'Completed' && task.status_name !== 'Cancelled'" class="fa fa-check" title="Mark Task Completed" (click)="openPromptModal(modalMarkTaskCompleted,task, prefixDamageReport)"></i>
                                                <i class="fa fa-trash" title="Delete Task" (click)="openPromptModal(modalDeleteTask,task, prefixDamageReport)"></i></small>
                                            </td>
                                            <td><small class="text-muted">{{task.title}}</small></td>
                                            <td><small>{{task.assignedTo_name}}</small></td>
                                            <td><small>{{task.percent_done}}</small></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="bg-white text-center">
                                            <small><pagination-controls autoHide="true" (pageChange)="drp = $event" maxSize="10"></pagination-controls></small>
                                        </div>  
                                    </div>
                                </div> 
                            </div>
                        </div>  
                    </div>  
                    <div *ngIf="!selectedDamage.length"><p >*No Recorded Task for this Damage Report.</p> </div>
                </div>
            </div> -->
      
        <!-- DETAILS SIDEBAR -->

    </div> <!-- END ROW -->
    <div class="row">
        <div class="col-md-12">
            <small><i>Click on a row to select. Details on a selected row are shown on the right window.</i></small>
        </div>
    </div>
</div>
<!-- END TAB B -->

<!-- START OF ADD REPAIR REQUEST FORM -->
<ng-template #modalRepairRequest let-close="close">
    <div class="modal-header">
        <h5 class="modal-title" *ngIf="isEditMode==false">Add New Repair Request</h5>
        <h5 class="modal-title" *ngIf="isEditMode==true">Edit Repair Request</h5>
        <button type="button" class="close" (click)="modalClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="repairRequestForm" novalidate (ngSubmit)="onSubmitRepairRequest(repairRequestForm.value)">
    <div class="modal-body">
        <div class="row pt-0">
            <div class="form-group col-md-4" >
                <h6>Date<span class="text-danger">*</span> :</h6>
                <input formControlName="date_submitted" class="form-control form-control-sm" type="date" required>
                <div *ngIf="repairRequestForm.controls.date_submitted.touched">
                    <div *ngIf="repairRequestForm.controls.date_submitted.errors?.required">
                        <small class="text-danger" >This field is required.</small>
                    </div>
                </div>
            </div>
            <div class="form-group col-md-4">
                <h6>Time<span class="text-danger">*</span> :</h6>
                <ngb-timepicker formControlName="time_string" [meridian]="true" required></ngb-timepicker>
                <div *ngIf="repairRequestForm.controls.time_string.touched">
                    <div *ngIf="repairRequestForm.controls.time_string.errors?.required">
                        <small class="text-danger" >This field is required.</small>
                    </div>
                </div>  
            </div>  
            <div class="col-lg-4 col-md-4 mb-4">
                <h6>Rating<span class="text-danger">*</span> :</h6>
                <select class="form-control form-control-sm" placeholder="Select" formControlName="rating_id" required>
                    <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                    <option *ngFor="let r of ratings" value="{{r.id}}">{{r.name}}</option>
                </select>
                <div *ngIf="repairRequestForm.controls.rating_id.touched">
                    <div *ngIf="repairRequestForm.controls.rating_id.errors?.required">
                        <small class="text-danger" >This field is required.</small>
                    </div>
                </div> 
            </div>
        
            <div class="form-group col-md-4">
                <h6>Driver<span class="text-danger">*</span> :</h6>
                <select [id]="driver_id" class="form-control form-control-sm" placeholder="Select" formControlName="driver_id" required>
                    <option disabled selected *ngIf="isEditMode==false">Select..</option>
                    <option *ngFor="let dr of drivers" value="{{dr.id}}">{{dr.full_name}}</option>
                </select>
                <div *ngIf="repairRequestForm.controls.driver_id.touched">
                    <div *ngIf="repairRequestForm.controls.driver_id.errors?.required">
                        <small class="text-danger" >This field is required.</small>
                    </div>
                </div>
            </div>
            <div class="form-group col-md-4">
                <h6>Fleet<span class="text-danger">*</span> :</h6>
                <select [id]="fleet_id" class="form-control form-control-sm" placeholder="Select" formControlName="fleet_id" required>
                    <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                    <option *ngFor="let fl of fleet" value="{{fl.id}}">{{fl.fleet_id_num}} ({{fl.rego}})</option>
                </select>
                <div *ngIf="repairRequestForm.controls.fleet_id.touched">
                    <div *ngIf="repairRequestForm.controls.fleet_id.errors?.required">
                        <small class="text-danger" >This field is required.</small>
                    </div>
                </div>
            </div>
            <div class="form-group col-md-4">
                <h6>Status <span class="text-danger">*</span> :</h6>
                <select class="form-control form-control-sm" placeholder="Select" formControlName="status_id">
                    <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                    <option *ngFor="let rs of repair_request_statuses" value="{{rs.id}}">{{rs.name}}</option>
                </select>
            </div>
        
            <div class="form-group col-md-4" >
                <h6>Description<span class="text-danger">*</span> :</h6>
                <input formControlName="text" class="form-control form-control-sm" type="text">
                <div *ngIf="repairRequestForm.controls.text.touched">
                    <div *ngIf="repairRequestForm.controls.text.errors?.required">
                        <small class="text-danger" >This field is required.</small>
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <div class="form-group form-control-sm" *ngIf ="(fileExists==true)">
                    <h6>File:</h6><br/>
                    <label>{{repairRequest?.filename}}</label> <button class="btn btn-primary btn-sm" type="button" (click)="removeFile(prefixRepairRequest)">Remove File</button>
                </div>
                <div class="form-group" *ngIf ="(fileExists==false)">
                    <h6>File:</h6>
                    <app-image-uploader  (passImage)="getFile($event, prefixRepairRequest)"></app-image-uploader>
                </div>
                <small><i>*Note: Allowed files are *.pdf, image files (*png,*.jpg,*.gif).</i></small>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button *ngIf="isEditMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="!repairRequestForm.valid || spinner == true">Save</button>
        <button *ngIf="isEditMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="!repairRequestForm.valid || spinner == true">Save Changes</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="modalClose()" ngbAutofocus>Cancel</button>
    </div>
    </form>
</ng-template>
<!-- END OF MODAL ADD REPAIR REQUEST FORM -->

<!-- START OF ADD DAMAGE REPORT FORM -->
<ng-template #modalDamageReport let-close="close">
    <div class="modal-header">
        <h5 class="modal-title" *ngIf="isEditMode==false">Add New Damage Report</h5>
            <h5 class="modal-title" *ngIf="isEditMode==true">Edit Damage Report</h5>
        <button type="button" class="close" (click)="modalClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="damageReportForm" novalidate (ngSubmit)="onSubmitDamageReport(damageReportForm.value)">
        <div class="modal-body">
            <div class="row pt-0">
                <div class="form-group col-md-4" >
                    <h6>Date<span class="text-danger">*</span> :</h6>
                    <input formControlName="date_submitted" class="form-control form-control-sm" type="date" max="{{dateNow|date:'yyyy-MM-dd'}}" required>
                    <div *ngIf="damageReportForm.controls.date_submitted.touched">
                        <div *ngIf="damageReportForm.controls.date_submitted.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>

                <div class="form-group col-md-4"> 
                    <h6>Time<span class="text-danger">*</span> :</h6>
                    <ngb-timepicker formControlName="time_string" [meridian]="false" required></ngb-timepicker> 
                    <div *ngIf="damageReportForm.controls.time_string.touched">
                        <div *ngIf="damageReportForm.controls.time_string.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>  
                </div>  
                <div class="form-group col-md-4">
                    <h6>Rating<span class="text-danger">*</span> :</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="rating_id" required>
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let r of ratings" value="{{r.id}}">{{r.name}}</option>
                    </select>
                    <div *ngIf="damageReportForm.controls.rating_id.touched">
                        <div *ngIf="damageReportForm.controls.rating_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
            
                <div class="form-group col-md-3">
                    <h6>Driver<span class="text-danger">*</span> :</h6>
                    <select [id]="driver_id" class="form-control form-control-sm" placeholder="Select" formControlName="driver_id" required>
                        <option disabled selected *ngIf="isEditMode==false">Select..</option>
                        <option *ngFor="let dr of drivers" value="{{dr.id}}">{{dr.full_name}}</option>
                    </select>
                    <div *ngIf="damageReportForm.controls.driver_id.touched">
                        <div *ngIf="damageReportForm.controls.driver_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-3">
                    <h6>Fleet<span class="text-danger">*</span> :</h6>
                    <select [id]="fleet_id" class="form-control form-control-sm" placeholder="Select" formControlName="fleet_id" required> 
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let fl of fleet" value="{{fl.id}}">{{fl.fleet_id_num}} ({{fl.rego}})</option>
                    </select>
                    <div *ngIf="damageReportForm.controls.fleet_id.touched">
                        <div *ngIf="damageReportForm.controls.fleet_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <!-- <div class="form-group col-md-4">
                    <h6>Status<span class="text-danger">*</span> :</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="status_id" required> 
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let rs of rrq_status" value="{{rs.id}}">{{rs.name}}</option>
                    </select>
                    <div *ngIf="damageReportForm.controls.status_id.touched">
                        <div *ngIf="damageReportForm.controls.status_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div> -->

                <div class="form-group col-md-3" >
                    <h6>Location<span class="text-danger">*</span> :</h6>
                    <input formControlName="location" class="form-control form-control-sm" type="text" required> 
                    <div *ngIf="damageReportForm.controls.location.touched">
                        <div *ngIf="damageReportForm.controls.location.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
            
                <div class="form-group col-md-3" >
                    <h6>Description<span class="text-danger">*</span> :</h6>
                    <input formControlName="text" class="form-control form-control-sm" type="text" required> 
                    <div *ngIf="damageReportForm.controls.text.touched">
                        <div *ngIf="damageReportForm.controls.text.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                
                <div class="row" style="padding-left: 10px;" *ngIf="(fileExists1 == false)">
                    <div class="col-md-12"style="padding-left: 10px;">
                        <div class="form-group" style="padding-left: 10px;">
                            <app-multiple-image-uploader (passImages)="getImages($event)"></app-multiple-image-uploader>
                        </div>
                    </div>
                </div>
            </div>
                    
              
             
                        <div class="row"  *ngIf="(fileExists1 == true)">
                            <div class="col-md-3">
                                <div class="form-group" *ngIf="(fileExists1 == true)" style="padding-left: 10px;">
                                    <h6 style="padding-left: 3px;">Image File1<span class="text-danger">*</span> :</h6><small><i>(jpg, jpeg, png ...)</i></small><br/>
                                    <img *ngIf="damageReport?.file1!= '' && damageReport?.question_id == null" src="{{fileStoragePath}}/report/{{damageReport?.file1}}" class="imgsize">
                                    <img *ngIf="damageReport?.file1!= '' && damageReport?.question_id != null" src="{{fileStoragePath}}/report/photos/{{damageReport.id}}/{{damageReport?.file1}}" class="imgsize">
                                </div>
                            </div>
    
                            <div class="col-md-3">
                                <div class="form-group" *ngIf="(fileExists2 == true)" style="padding-left: 10px;">
                                    <h6 style="padding-left: 3px;">Image File2<span class="text-danger">*</span> :</h6><small><i>(jpg, jpeg, png ...)</i></small><br/>
                                    <img *ngIf="damageReport?.file2!= '' && damageReport?.question_id == null " src="{{fileStoragePath}}/report/{{damageReport?.file2}}" class="imgsize">
                                    <img *ngIf="damageReport?.file2!= '' && damageReport?.question_id != null" src="{{fileStoragePath}}/report/photos/{{damageReport.id}}/{{damageReport?.file2}}" class="imgsize">
                                </div>
                            </div>
    
                            <div class="col-md-3">
                                <div class="form-group" *ngIf="(fileExists3 == true)" style="padding-left: 10px;">
                                    <h6 style="padding-left: 3px;">Image File3<span class="text-danger">*</span> :</h6><small><i>(jpg, jpeg, png ...)</i></small><br/>
                                    <img *ngIf="damageReport?.file3!= '' && damageReport?.question_id == null" src="{{fileStoragePath}}/report/{{damageReport?.file3}}" class="imgsize">
                                    <img *ngIf="damageReport?.file3!= '' && damageReport?.question_id != null" src="{{fileStoragePath}}/report/photos/{{damageReport.id}}/{{damageReport?.file3}}" class="imgsize">
                                </div>
                            </div>
    
                            <div class="col-md-3">
                                <div class="form-group" *ngIf="(fileExists4 == true)" style="padding-left: 10px;">
                                    <h6 style="padding-left: 3px;">Image File4<span class="text-danger">*</span> :</h6><small><i>(jpg, jpeg, png ...)</i></small><br/>
                                    <img *ngIf="damageReport?.file4!= '' && damageReport?.question_id == null" src="{{fileStoragePath}}/report/{{damageReport?.file4}}" class="imgsize">
                                    <img *ngIf="damageReport?.file4!= '' && damageReport?.question_id != null" src="{{fileStoragePath}}/report/photos/{{damageReport.id}}/{{damageReport?.file4}}" class="imgsize">
                                </div>
                            </div>
                        </div>
                

                    <div class="row" *ngIf="(fileExists5 == true)">
                        <div class="col-md-3">
                            <div class="form-group" *ngIf="(fileExists5 == true)" style="padding-left: 10px;">
                                <h6 style="padding-left: 3px;">Image File5<span class="text-danger">*</span> :</h6><small><i>(jpg, jpeg, png ...)</i></small><br/>
                                <img *ngIf="damageReport?.file5!= '' && damageReport?.question_id == null" src="{{fileStoragePath}}/report/{{damageReport?.file5}}" class="imgsize">
                                <img *ngIf="damageReport?.file5!= '' && damageReport?.question_id != null" src="{{fileStoragePath}}/report/photos/{{damageReport.id}}/{{damageReport?.file5}}" class="imgsize">
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group" *ngIf="(fileExists6 == true)" style="padding-left: 10px;">
                                <h6 style="padding-left: 3px;">Image File6<span class="text-danger">*</span> :</h6><small><i>(jpg, jpeg, png ...)</i></small><br/>
                                <img *ngIf="damageReport?.file6!= '' && damageReport?.question_id == null" src="{{fileStoragePath}}/report/{{damageReport?.file6}}" class="imgsize">
                                <img *ngIf="damageReport?.file6!= '' && damageReport?.question_id != null" src="{{fileStoragePath}}/report/photos/{{damageReport.id}}/{{damageReport?.file6}}" class="imgsize">
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group" *ngIf="(fileExists7 == true)" style="padding-left: 10px;">
                                <h6 style="padding-left: 3px;">Image File7<span class="text-danger">*</span> :</h6><small><i>(jpg, jpeg, png ...)</i></small><br/>
                                <img *ngIf="damageReport?.file7!= '' && damageReport?.question_id == null" src="{{fileStoragePath}}/report/{{damageReport?.file7}}" class="imgsize">
                                <img *ngIf="damageReport?.file7!= '' && damageReport?.question_id != null" src="{{fileStoragePath}}/report/photos/{{damageReport.id}}/{{damageReport?.file7}}" class="imgsize">
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group" *ngIf="(fileExists8 == true)" style="padding-left: 10px;">
                                <h6 style="padding-left: 3px;">Image File8<span class="text-danger">*</span> :</h6><small><i>(jpg, jpeg, png ...)</i></small><br/>
                                <img *ngIf="damageReport?.file8!= '' && damageReport?.question_id == null" src="{{fileStoragePath}}/report/{{damageReport?.file8}}" class="imgsize">
                                <img *ngIf="damageReport?.file8!= '' && damageReport?.question_id != null" src="{{fileStoragePath}}/report/photos/{{damageReport.id}}/{{damageReport?.file8}}" class="imgsize">
                            </div>
                        </div>
                    </div>


                    <div class="row" *ngIf="(fileExists9 == true)" >
                        <div class="col-md-6">
                            <div class="form-group" *ngIf="(fileExists9 == true)" style="padding-left: 10px;">
                                <h6 style="padding-left: 3px;">Image File9<span class="text-danger">*</span> :</h6><small><i>(jpg, jpeg, png ...)</i></small><br/>
                                <img *ngIf="damageReport?.file9!= '' && damageReport?.question_id == null" src="{{fileStoragePath}}/report/{{damageReport?.file9}}" class="imgsize">
                                <img *ngIf="damageReport?.file9!= '' && damageReport?.question_id != null" src="{{fileStoragePath}}/report/photos/{{damageReport.id}}/{{damageReport?.file9}}" class="imgsize">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group" *ngIf="(fileExists10 == true)" style="padding-left: 10px;">
                                <h6 style="padding-left: 3px;">Image File10<span class="text-danger">*</span> :</h6><small><i>(jpg, jpeg, png ...)</i></small><br/>
                                <img *ngIf="damageReport?.file10!= '' && damageReport?.question_id == null" src="{{fileStoragePath}}/report/{{damageReport?.file10}}" class="imgsize">
                                <img *ngIf="damageReport?.file10!= '' && damageReport?.question_id != null" src="{{fileStoragePath}}/report/photos/{{damageReport.id}}/{{damageReport?.file10}}" class="imgsize">
                            </div>
                        </div>
                    </div>
                        
           
        
        </div>
        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button *ngIf="isEditMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="!damageReportForm.valid || spinner == true">Save</button>
            <button *ngIf="isEditMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="!damageReportForm.valid || spinner == true">Save Changes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="modalClose()" ngbAutofocus >Cancel</button>
        </div>
    </form> 
</ng-template>
<!-- END OF MODAL ADD DAMAGE REPORT FORM -->

<!-- START OF DELETE OBJECT FORM -->
<ng-template #modalDeleteObj let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete {{title}}</h5>
        <button type="button" class="close" (click)="modalClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body bg-gray">
        <div class="row">
            <div class="col-md-12">
            Do you really want to delete this {{title}}?
            <h5>{{objToDelete.rego}}</h5>
            <label>{{fileToDelete}}</label>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger"  (click)="deleteObj(objToDelete)"  [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="modalClose()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE OBJECT FORM -->

<!-- START REPAIR REQUEST PRINT-->
<div id="repairrequest-print-section" style="display:none">
    <table style="width:100%">
        <tr>
            <th align="left" *ngIf="showRequestDate">DATE</th>
            <th align="left" *ngIf="showRequestRego">REGO</th>
            <th align="left" *ngIf="showRequestFleetType">FLEET TYPE</th>
            <th align="left" *ngIf="showRequestDescription">DESCRIPTION</th>
            <th align="left" *ngIf="showRequestFile">FILE</th>
        </tr>
        <tr *ngFor="let row of request_rows">
            <td *ngIf="showRequestDate">{{ (formatDate(row.date_submitted) !== null && row.date_submitted != '0000-00-00') ? (formatDate(row.date_submitted) | date: 'dd MMM yyyy') : "No Date"  }}  </td> 
            <td *ngIf="showRequestRego">{{row.rego}}</td>
            <td *ngIf="showRequestFleetType">{{row.fleet_type}}</td>
            <td *ngIf="showRequestDescription">{{row.text}}</td>
            <td *ngIf="showRequestFile"><div class="justify-content-left"><a href="{{fileStoragePath}}/repairrequest/{{row.filename}}" target="_new">{{row.filename}}</a></div></td>
        </tr>
    </table>
</div>
<!-- END PRINT -->

<!-- START REPAIR REQUEST PRINT-->
<div id="repairpairing-print-section" style="display:none">
    <table style="width:100%">
        <tr>
            <th align="left" *ngIf="showPairingRequestID">REQUEST ID</th>
            <th align="left" *ngIf="showPairingDesc">DATE</th>
            <th align="left" *ngIf="showPairingDriver">DRIVER NAME</th>
            <th align="left" *ngIf="showPairingRating">RATING</th>
            <th align="left" *ngIf="showPairingStatus">STATUS</th>
        </tr>
        <tr *ngFor="let row of request_pairings_rows">
            <td *ngIf="showPairingRequestID"> {{row.request_id}}  </td> 
            <td *ngIf="showPairingDesc"> {{row.description}}  </td> 
            <td *ngIf="showPairingDriver">{{row.driver_name}}</td>
            <td *ngIf="showPairingRating">{{row.rating_name}}</td>
            <td *ngIf="showPairingStatus">{{row.status_name}}</td>
        </tr>
    </table>
</div>
<!-- END PRINT -->

<!-- START DAMAGE REPORT PRINT-->
<div id="report-print-section" style="display:none">
    <table style="width:100%">
        <tr>
            <th align="left" *ngIf="showDate">DATE</th>
            <th align="left" *ngIf="showRego">REGO</th>
            <th align="left" *ngIf="showFleetType">FLEET TYPE</th>
            <th align="left" *ngIf="showDescription">DESCRIPTION</th>
            <th align="left" *ngIf="showFile">FILE</th>
        </tr>
        <tr *ngFor="let row of damage_rows">
            <td *ngIf="showDate">{{ (formatDate(row.date_submitted) !== null && row.date_submitted != '0000-00-00') ? (formatDate(row.date_submitted) | date: 'dd MMM yyyy') : "No Date"  }}  </td>
            <td *ngIf="showRego">{{row.rego}}</td>
            <td *ngIf="showFleetType">{{row.fleet_type}} - {{row.subtype}}</td>
            <td *ngIf="showDescription">{{row.text}}</td>
            <td *ngIf="showFile"><div class="justify-content-left"><a href="{{fileStoragePath}}/report/{{row.file}}" target="_new">{{row.file}}</a></div></td>
        </tr>
    </table>
</div>
<!-- END PRINT -->

<!--- START OF MARK ALL TASK COMPLETED MODAL -->
<ng-template #modalMarkCompleted let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Mark Task as Completed</h5>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                {{modalCaller}} Description: <b *ngIf="modalCaller=='Repair Request'"><i>{{selected2[0].text}}</i></b><b *ngIf="modalCaller=='Damage Report'"><i>{{selected3[0].text}}</i></b> <br/>
                Driver: <b *ngIf="modalCaller=='Repair Request'"><i>{{selected2[0].driver_name}}</i></b><b *ngIf="modalCaller=='Damage Report'"><i>{{selected3[0].driver_name}}</i></b> <br/> <br/>
                <p>Are you sure you want to mark all task for this {{modalCaller}} completed?</p>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button *ngIf="modalCaller=='Repair Request'" type="button" class="btn btn-sm btn-success" (click)="markCompleted(selected2[0].id, prefixRepairRequest)"  [disabled]="spinner == true">
            Yes</button>
        <button *ngIf="modalCaller=='Damage Report'" type="button" class="btn btn-sm btn-success" (click)="markCompleted(selected3[0].id, prefixDamageReport)"  [disabled]="spinner == true">
            Yes</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">No</button>
    </div>
</ng-template>
<!-- END OF MARK ALL TASK COMPLETED MODAL -->

<!--- START OF MARK TASK COMPLETED MODAL -->
<ng-template #modalMarkTaskCompleted let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Mark Task Completed</h5>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                Task Title: <b><i>{{task.title}}</i></b><br/> <br/>
                <p>Are you sure you want to mark this task as completed?</p>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-success" (click)="markTaskCompleted(task.id, caller)"  [disabled]="spinner == true"><i class="fa fa-check-square-o"></i>  Yes</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">No</button>
    </div>
</ng-template>
<!-- END OF MARK TASK COMPLETED MODAL -->

<!-- START OF DELETE TASK FORM -->
<ng-template #modalDeleteTask let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete Task</h5>
        <button type="button" class="close" (click)="modalClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="row modal-body">
        <div class="col-md-12">
            Do you really want to delete <b><i>{{task.title}}</i></b>?
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-danger"  (click)="deleteTask(task.id)"  [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-secondary" (click)="modalClose()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE TASK FORM -->

<!-- START OF TASK MODAL FORM -->
<ng-template #modalTaskForm let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">{{action}} Task</h5>
        <button type="button" class="close" (click)="modalClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <app-addupdatetask *ngIf="modalCaller=='Repair Request'" [task]="task ? task : null" [caller]="prefixRepairRequest" [objectId]="repairRequestId" (closeModal)="closeModalTask(prefixRepairRequest)"></app-addupdatetask>
    <app-addupdatetask *ngIf="modalCaller=='Damage Report'" [task]="task ? task : null" [caller]="prefixDamageReport" [objectId]="damageReportId" (closeModal)="closeModalTask(prefixDamageReport)"></app-addupdatetask>
</ng-template>
<!-- END OF TASK MODAL FORM -->


<!-- START OF ADD RR FORM -->
<ng-template #modalRR let-close="close">
    <div class="modal-header">
        <h5 class="modal-title" *ngIf="isEditMode==false">Add New Repair Request</h5>
        <h5 class="modal-title" *ngIf="isEditMode==true">Edit Repair Request</h5>
        <button type="button" class="close" (click)="modalClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="repairRequestFormChanges" (ngSubmit)="onSubmitRepairRequestChanges(repairRequestFormChanges.value)">
        <div class="modal-body">
            <div class="row pt-0">

                <div class="form-group col-md-3" >
                    <h6>Date<span class="text-danger">*</span> :</h6>
                    <input formControlName="date_submitted"  class="form-control form-control-sm" type="date" max="{{dateNow|date:'yyyy-MM-dd'}}">
                </div>

                <!-- <div class="col-lg-4 col-md-4 mb-4">
                    <h6>Rating<span class="text-danger">*</span> :</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="rating_id">
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let r of ratings" value="{{r.id}}">{{r.name}}</option>
                    </select>
                </div> -->
            
                <!-- <div class="form-group col-md-4">
                    <h6>Fleet<span class="text-danger">*</span> :</h6>
                    <select [id]="fleet_id" class="form-control form-control-sm" placeholder="Select" formControlName="fleet_id">
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let fl of fleet" value="{{fl.id}}">{{fl.fleet_id_num}} ({{fl.rego}})</option>
                    </select>
                </div> -->
                <div class="form-group col-md-3">
                    <h6>Status<span class="text-danger">*</span> :</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="status_id">
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let rs of rrq_status" value="{{rs.id}}">{{rs.name}}</option>
                    </select>
                </div>

                <div class="form-group col-md-3">
                    <h6>Time<span class="text-danger">*</span> :</h6>
                    <ngb-timepicker formControlName="time_string" [meridian]="true" required></ngb-timepicker>
                </div>  
            
                <div class="form-group col-md-3 mb-4" >
                    <h6>Notes<span class="text-danger">*</span> :</h6>
                    <textarea class="form-control form-control-sm" rows="2" cols="50" formControlName="text"></textarea>
                </div>
              <!-- <div class="col-md-4">
                    <div class="form-group form-control-sm" *ngIf ="(fileExists==true)">
                        <h6>File:</h6><br/>
                        <label>{{repairRequest?.filename}}</label> <button class="btn btn-primary btn-sm" type="button" (click)="removeFile(prefixRepairRequest)">Remove File</button>
                    </div>
                    <div class="form-group" *ngIf ="(fileExists==false)">
                        <h6>File:</h6>
                        <app-image-uploader (passImage)="getFile($event, prefixRepairRequest)"></app-image-uploader>
                    </div>
                    <small><i>*Note: Allowed files are *.pdf, image files (*png,*.jpg,*.gif).</i></small>
                </div> -->

                <div class="form-group col-md-6" *ngIf="isEditMode==false">
                    <div class="autocomplete">
                        <div class="chips-input-container">
                                <button *ngIf="!show" name="damage_rows"  (click)="suggest()" class="btn btn-secondary btn-sm mb-1 ml-1">Select Damage Report</button>
                                <button *ngIf="show"  (click)="closeRR()" class="btn btn-secondary btn-sm mb-1 ml-1 ">Close <i class="fa fa-times-circle ml-1" aria-hidden="true"></i></button>
                        </div>
                
                        <div class="autocomplete-items col-md-10" *ngIf="show">
                                <div *ngFor="let damage of selectRows" class="TXT">
                                    <div  [ngClass]="isSelected(damage) ? 'selected-suggestion' : ''"  (click)="selectSuggestion(damage)">
                                        {{ damage.text }}
                                    </div>
                                </div>
                        </div>
                
                    </div>
                </div>

                <div class="form-group col" *ngIf="isEditMode==false">
                    <div class="user-chip" *ngFor="let user of userSelects">
                        <div *ngIf="user.status_id == 1" >
                        {{user.file}} <i class="fa fa-times" aria-hidden="true" (click)="deleteSelects(user)"></i>
                        </div>
                        
                    </div>
                </div>

            </div>
        </div>
        
        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button type="submit" class="btn btn-sm btn-success" *ngIf="isEditMode==false" [disabled]="!repairRequestFormChanges.valid || spinner == true">Save</button>
            <button type="submit" class="btn btn-sm btn-success" *ngIf="isEditMode==true" [disabled]="!repairRequestFormChanges.valid || spinner == true">Save Changes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="modalClose()" ngbAutofocus >Cancel</button>
        </div>
    </form> 
</ng-template>
<!-- END OF MODAL RR REPORT FORM -->


<!-- START OF ADD REPAIR FORM -->
<ng-template #modalRepair let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Add New Repair</h5>
        <button type="button" class="close" (click)="modalClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="repairForm" novalidate (ngSubmit)="onSubmitRepair(repairForm.value)">
        <div class="modal-body bg-gray">
            <div class="row pt-0">
                <div class="form-group col-md-4" >
                    <h6>Date<span class="text-danger">*</span> :</h6>
                    <input formControlName="date_done" class="form-control form-control-sm" type="date" required> 
                    <div *ngIf="repairForm.controls.date_done.touched">
                        <div *ngIf="repairForm.controls.date_done.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4"> 
                    <h6>Time :</h6>
                    <ngb-timepicker formControlName="time_string" [meridian]="true" class="changeSize"></ngb-timepicker>
                </div>
                <div class="form-group col-md-4" >
                    <h6>Cost<span class="text-danger">*</span> :</h6>
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend"><div class="input-group-text">$</div></div>
                    <input formControlName="cost" class="form-control form-control-sm" type="text" required>
                    </div>
                    <div *ngIf="repairForm.controls.cost.touched">
                        <div *ngIf="repairForm.controls.cost.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                        <div *ngIf="repairForm.controls.cost.errors?.pattern && !isCost()">
                            <small class="text-danger" >Cost must have a valid currency value.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <h6>Provider<span class="text-danger">*</span> :</h6>
                    <select [id]="driver_id" class="form-control form-control-sm" placeholder="Select" formControlName="provider_id" required>
                        <option disabled selected *ngIf="isEditMode==false">Select..</option>
                        <option *ngFor="let p of providers" value="{{p.id}}">{{p.company_name}}</option>
                    </select>
                    <div *ngIf="repairForm.controls.provider_id.touched">
                        <div *ngIf="repairForm.controls.provider_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>

                <div class="form-group col-md-4">
                    <h6>Fleet<span class="text-danger">*</span> :</h6>
                    <select [id]="fleet_id" class="form-control form-control-sm" placeholder="Select" formControlName="fleet_id" required> 
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let fl of fleet" value="{{fl.id}}">{{fl.fleet_id_num}} ({{fl.rego}})</option>
                    </select>
                    <div *ngIf="repairForm.controls.fleet_id.touched">
                        <div *ngIf="repairForm.controls.fleet_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4" >
                    <h6>Description<span class="text-danger">*</span> :</h6>
                    <input formControlName="repair_description" class="form-control form-control-sm" type="text" required>
                    <div *ngIf="repairForm.controls.repair_description.touched">
                        <div *ngIf="repairForm.controls.repair_description.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4" >
                    <h6>Receipt No<span class="text-danger">*</span> :</h6>
                    <input formControlName="receipt_no" class="form-control form-control-sm" type="text" required>
                    <div *ngIf="repairForm.controls.receipt_no.touched">
                        <div *ngIf="repairForm.controls.receipt_no.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                        <div *ngIf="repairForm.controls.receipt_no.errors?.pattern">
                            <small class="text-danger" >This field requires numeric values only.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4" >
                    <h6>Fault<span class="text-danger">*</span> :</h6>
                    <input formControlName="fault" class="form-control form-control-sm" type="text" required>
                    <div *ngIf="repairForm.controls.fault.touched">
                        <div *ngIf="repairForm.controls.fault.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4" >
                    <h6>Note:</h6>
                    <input formControlName="note" class="form-control form-control-sm" type="text">
                </div>
                <div class="form-group col-md-4" >
                    <h6>Hours :</h6>
                    <input formControlName="hours" class="form-control form-control-sm" type="text"> 
                </div>
                <div class="form-group col-md-4" >
                    <h6>Odometer: <span class="text-danger">*</span></h6>
                    <input formControlName="mileage" class="form-control form-control-sm" type="text">
                    <div *ngIf="repairForm.controls.mileage.touched">
                        <div *ngIf="repairForm.controls.mileage.errors?.pattern && !isMileage()">
                            <small class="text-danger" >This field requires numeric values only.</small>
                        </div>
                    </div>
                </div>
              <div class="col-md-4">
                    <div class="form-group" *ngIf ="(fileExists==true)">
                        <h6>File:</h6><br/>
                        <label>{{repair?.file}}</label> <button class="btn btn-primary btn-sm" type="button" (click)="removeFile(prefixRepair)">Remove File</button>
                    </div>
                    <div class="form-group" *ngIf ="(fileExists==false)">
                        <h6>File :</h6>
                        <app-image-uploader (passImage)="getFile($event, prefixRepair)"></app-image-uploader>
                    </div>
                    <small><i>*Note: Allowed files are *.pdf, image files (*png,*.jpg,*.gif).</i></small>
                </div> 

                <div class="col-md-12">
                    <div class="form-group">
                        <table class="table table-sm">
                            <thead>
                                <tr>
                                    <th>Mark as Done</th>
                                    <th>Driver Name</th>
                                    <th>Rating Name</th>
                                    <th>Description</th>
                                    <th>Status Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor = "let data of getData,let n = index ">
                                    <td width="5%"> <input type="checkbox"
                                        name="data[{{n}}]"  [value]="data" 
                                        (change)="updateCheckedOptions(data,$event)"
                                         /></td>
                                    <ng-container>
                                        <td>{{data.driver_name}}</td>
                                    </ng-container>
                                    <td> {{data.rating_name}}</td>
                                    <td> {{data.description}}</td>
                                    <td> {{data.status_name}}</td>
    
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button  type="submit" class="btn btn-sm btn-success" [disabled]="!repairForm.valid || spinner == true" >Save</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="modalClose()" ngbAutofocus>Cancel</button>
        </div>
    </form>
</ng-template>
<!-- END OF MODAL ADD REPAIR FORM -->


<!-- START OF CANCEL SELECTED REQUESTS -->
<ng-template #modalSelectCancel let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Select Request to Cancel  </h5>
        <button type="button" class="close" (click)="modalClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="cancelRequestPairingForm">
    <div class="row modal-body">
        <div class="col-md-12">
            <div class="form-group">
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>Mark as Done</th>
                            <th>Driver Name</th>
                            <th>Rating Name</th>
                            <th>Description</th>
                            <th>Status Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor = "let data of cancelRequests,let n = index ">
                            <td width="5%"> <input type="checkbox"
                                name="data[{{n}}]"  [value]="data" 
                                (change)="updateCancelOptions(data,$event)"
                                 /></td>
                            <ng-container>
                                <td>{{data.driver_name}}</td>
                            </ng-container>
                            <td> {{data.rating_name}}</td>
                            <td> {{data.description}}</td>
                            <td> {{data.status_name}}</td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-danger" (click)="onSubmitCancelRequests(cancelRequestPairingForm.value)"  [disabled]="!cancelRequestPairingForm.valid || spinner == true">Cancel Requests</button>
        <button type="button" class="btn btn-secondary" (click)="modalClose()">Close</button>
    </div>
    </form>
</ng-template>
<!-- END OF CANCEL SELECTED REQUESTS -->

<!-- START OF CANCEL ALL REQUEST FORM -->
<ng-template #modalCancelAll let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Cancel All Requests</h5>
        <button type="button" class="close" (click)="modalClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body bg-gray">
        <div class="row">
            <div class="col-md-12">
            Do you really want to cancel all requests?
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger"  (click)="cancelObj()"  [disabled]="spinner == true">Cancel Requests</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="modalClose()">Close</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE OBJECT FORM -->


<ng-template #selectActionModal let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Select An Action</h5>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <!-- <div class="row modal-body">

    </div> -->
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary"   (click)="openCancelAllRequestsModal()">Cancel All Requests</button>
        <button type="button" class="btn btn-secondary"    (click)="openSelectCancelObjModal()">Select Request To Cancel</button>
        <button type="button" class="btn btn-danger" (click)="closeModal()">Cancel</button>
    </div>
</ng-template>

